let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eMKup")).then(() => parcelRequire('hqpaf'));